export { default } from "./LifeEventList";
export {tagList, ILifeEvent, Tags} from "./LifeEvent";